var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',{class:['cookies-container']},[_c('p',[_vm._v("This website uses cookies to offer you the most relevant information. Please accept for optimal performance. ")]),_c('b-button',{on:{"click":_vm.closeCookies}},[_vm._v("Accept")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }